import { useEffect, useState } from "react";
import {
  getClientDataByRefNumber,
  getUserIDs,
  unmapTelecallerID,
  updateTelecallerUserID,
} from "./services/telecallerIDUpdation.service";
import { toast } from "react-toastify";
import { Constants } from "../../CommonMethhods/Constants";

export const useTelecallerIDUpdation = () => {
  const [isLoading, setIsLoading] = useState();

  const updateTelecallerID = async (payload) => {
    setIsLoading(true);

    try {
      const response = await updateTelecallerUserID(payload);
      if (response.status === 0) {
        return { success: true, data: response };
      }
      return { success: false, data: response };
    } catch (error) {
      console.error(error);
      toast.error(Constants.GENERIC_ERROR_MESSAGE);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, updateTelecallerID };
};

export const useClientDetails = () => {
  const [isLoading, setIsLoading] = useState();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const fetchClientDataByRefNumber = async (payload) => {
    setIsLoading(true);
    setError("");

    try {
      const response = await getClientDataByRefNumber(payload);
      if (response.status === 0) {
        setData(response.data);
      } else {
        setError(response);
      }
    } catch (error) {
      console.error(error);
      setError(error.message);
      toast.error(Constants.GENERIC_ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, fetchClientDataByRefNumber, data, error };
};

export const useUserIDs = () => {
  const [isLoading, setIsLoading] = useState();
  const [userIDs, setUserIDs] = useState([]);
  const [error, setError] = useState("");

  const fetchUserIDs = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await getUserIDs();
      if (response.status === 0) {
        setUserIDs(response.data);
      } else {
        setError(response);
      }
    } catch (error) {
      console.error(error);
      setError(error.message);
      toast.error(Constants.GENERIC_ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserIDs();
  }, []);

  return { isLoading, fetchUserIDs, userIDs, error };
};

export const useUnmapTelecallerUserID = () => {
  const [isLoading, setIsLoading] = useState();

  const unmapTelecallerUserID = async (payload) => {
    setIsLoading(true);

    try {
      const response = await unmapTelecallerID(payload);
      if (response.status === 0) {
        return { success: true, data: response };
      }
      return { success: false, data: response };
    } catch (error) {
      console.error(error);
      toast.error(Constants.GENERIC_ERROR_MESSAGE);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, unmapTelecallerUserID };
};
